import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Completa todos los campos');
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Bienvenido!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Credenciales invalidas');
    } finally {
      setLoading(false);
    }
  };

  const f = { fontFamily:"'Plus Jakarta Sans',sans-serif" };

  return (
    <div style={{ ...f, minHeight:'100vh', background:'#f5f5ef', display:'flex', flexDirection:'column' }}>

      {/* NAVBAR */}
      <nav style={{ background:'#fff', borderBottom:'1px solid #e8e8e0', padding:'0 48px', height:60, display:'flex', alignItems:'center' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:32, height:32, borderRadius:10, background:'#d4f542', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2d4a00" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
          </div>
          <span style={{ fontSize:15, fontWeight:800, color:'#1a1a1a' }}>NovaEcom Analytics</span>
        </div>
      </nav>

      {/* MAIN */}
      <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 24px' }}>
        <div style={{ width:'100%', maxWidth:420 }}>

          {/* CARD */}
          <div style={{ background:'#fff', borderRadius:24, padding:40, border:'1px solid #e8e8e0', boxShadow:'0 4px 24px rgba(0,0,0,0.06)' }}>

            {/* Logo icon */}
            <div style={{ width:48, height:48, borderRadius:14, background:'#ede9fe', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:20 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7c5ef8" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>

            <h1 style={{ fontSize:24, fontWeight:800, color:'#1a1a1a', margin:'0 0 6px' }}>Bienvenido</h1>
            <p style={{ fontSize:14, color:'#aaa', marginBottom:32, margin:'0 0 32px' }}>
              Ingresa a tu cuenta de NovaEcom Analytics
            </p>

            <form onSubmit={handleLogin}>
              <div style={{ marginBottom:16 }}>
                <label style={{ fontSize:11, fontWeight:700, color:'#888', display:'block', marginBottom:7, textTransform:'uppercase', letterSpacing:'.5px' }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  style={{
                    width:'100%', background:'#fafaf5', border:'1.5px solid #e8e8e0',
                    borderRadius:12, padding:'13px 16px', fontSize:14, color:'#1a1a1a',
                    fontFamily:'Plus Jakarta Sans,sans-serif', outline:'none',
                    boxSizing:'border-box', transition:'border-color .15s'
                  }}
                  onFocus={e => e.target.style.borderColor='#7c5ef8'}
                  onBlur={e => e.target.style.borderColor='#e8e8e0'}
                />
              </div>

              <div style={{ marginBottom:28 }}>
                <label style={{ fontSize:11, fontWeight:700, color:'#888', display:'block', marginBottom:7, textTransform:'uppercase', letterSpacing:'.5px' }}>
                  Contraseña
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  style={{
                    width:'100%', background:'#fafaf5', border:'1.5px solid #e8e8e0',
                    borderRadius:12, padding:'13px 16px', fontSize:14, color:'#1a1a1a',
                    fontFamily:'Plus Jakarta Sans,sans-serif', outline:'none',
                    boxSizing:'border-box', transition:'border-color .15s'
                  }}
                  onFocus={e => e.target.style.borderColor='#7c5ef8'}
                  onBlur={e => e.target.style.borderColor='#e8e8e0'}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width:'100%', padding:15, borderRadius:12,
                  background: loading ? '#c4b5fd' : 'linear-gradient(135deg,#7c5ef8,#a855f7)',
                  border:'none', fontSize:15, fontWeight:700, color:'#fff',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                  transition:'opacity .2s'
                }}>
                {loading ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ animation:'spin 1s linear infinite' }}>
                      <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                    </svg>
                    Ingresando...
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                      <polyline points="10 17 15 12 10 7"/>
                      <line x1="15" y1="12" x2="3" y2="12"/>
                    </svg>
                    Iniciar Sesion
                  </>
                )}
              </button>
            </form>
          </div>

          <div style={{ textAlign:'center', marginTop:20, fontSize:12, color:'#bbb' }}>
            © 2024 NovaEcom Analytics · Datos seguros y encriptados.
          </div>
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
